module.exports = __webpack_public_path__ + "img/wifi-3.af79352a.png";